import { ReactNode } from "react";
import classNames from "classnames";

interface CardProps {
  children: ReactNode;
  header?: ReactNode;
  onClick?: () => void;
  id?: string;
  center?: boolean;
  additionalItem?: ReactNode;
  hasResponsiveHeader?: boolean;
}

export const Card = ({
  children,
  header,
  onClick,
  id,
  center,
  additionalItem,
  hasResponsiveHeader,
}: CardProps) => (
  <div
    id={id}
    className={classNames(
      "flex overflow-hidden flex-col w-full h-full bg-white rounded-lg p-2",
      {
        "cursor-pointer": !!onClick,
      }
    )}
    onClick={onClick}
  >
    <div
      className={`p-2 ${
        hasResponsiveHeader
          ? "lg:flex lg:justify-between"
          : "flex justify-between"
      }`}
    >
      {header && (
        <div
          className={`text-xl font-semibold text-brand ${
            hasResponsiveHeader && "pb-2 md:pb-0"
          }`}
        >
          {header}
        </div>
      )}
      {additionalItem && <div> {additionalItem}</div>}
    </div>
    {children}
  </div>
);
